// src/services/resourceService.js
import axios from 'axios';
import { toFormData } from './utils'; // Utility function

const resourceService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});


export const getResourceCategory = (reqData) => {
    const formData = toFormData(reqData);
    return resourceService.post('/resource-categories', formData);
};

export const getResourceYears = () => {
    return resourceService.get('/resources/years');
};

export const getResources = (blogData) => {
    const formData = toFormData(blogData);
    return resourceService.post('/resources', formData);
};

export const getResourceDetails = (slug) => {
    return resourceService.get('/resources/'+slug);
};

export default resourceService;
